export const SETTINGS_HEADER_TABLE = {
    trafficSource: 'trafficSource',
    trafficSourceParameters: 'trafficSourceParameters',
    vendor: 'vendor',
    buyer: 'buyer',
    buyerInvitations: 'buyerInvitations',
    vendorInvitations: 'vendorInvitations',
    destination: 'destination',
    campaignIncludeDestination: 'campaignIncludeDestination',
    destinationsGroup: 'destinationsGroup',
    destinationGroupParameters: 'destinationsGroupParameters',
    availableDestinationGroup: 'availableDestinationGroup',
    availableNumbersInNumberPool: 'availableNumbersInNumberPool',
    blockNumber: 'blockNumber',
    numberPool: 'numberPool',
    numberInPool: 'numberInPool',
    manageNumber: 'manageNumber',
    campaigns: 'campaigns',
    forwardCallsTo: 'forwardCallsTo',
    forwardCallsToByRevenue: 'forwardCallsToByRevenue',
    campaignTrackingNumber: 'campaignTrackingNumbers',
    campaignAvailableTrackingNumber: 'campaignAvailableTrackingNumber',
    campaignAvailableNumberPools: 'campaignAvailableNumberPools',
    campaignAvailableDestination: 'campaignAvailableDestination',
    campaignAvailableGroupDestination: 'campaignAvailableGroupDestination',
    campaignAccess: 'campaignAccess',
    campaignAddUsers: 'campaignAddUsers',
    campaignEnrichmentUrls: 'campaignEnrichmentUrls',
    loginSecurity: 'loginSecurity',
    apiAccessToken: 'apiAccessToken',
    paymentHistory: 'paymentHistory',
    manageCards: 'manageCards',
    callLog: 'callLog',
    aggregated: 'aggregated',
    workspaceActivity: 'workspaceActivity',
    reporting: 'reporting',
    callFlows: 'callFlows',
    voipShield: 'voipShield',
    blockedCarrier: 'blockedCarrier',
    customParameters: 'customParameters',
    leads: 'leads',
    callFlowAvailableDestinations: 'callFlowAvailableDestinations',
    callFlowAvailableGroups: 'callFlowAvailableGroups',
    detailGoogleIntegrationTrafficSource: 'detailGoogleIntegrationTrafficSource',
    detailFacebookIntegrationTrafficSource: 'detailFacebookIntegrationTrafficSource',
    detailIncomingWebhookIntegration: 'detailIncomingWebhookIntegration',
    detailOutgoingWebhookIntegration: 'detailOutgoingWebhookIntegration',
    detailLogsOutgoingWebhookIntegration: 'detailLogsOutgoingWebhookIntegration',
    byocIntegrationNumbers: 'byocIntegrationNumbers',
    byocIntegrationCarriers: 'byocIntegrationCarriers',
    googleConversation: 'googleConversation',
    facebookEvents: 'facebookEvents',
    detailNumberPoolTrafficSources: 'detailNumberPoolTrafficSources',
    detailNumberPoolAvailableTrafficSources: 'detailNumberPoolAvailableTrafficSources',
    pingLog: 'pingLog',
    workspaceUsers: 'workspaceUsers',
    numberPoolTrafficSources: 'numberPoolTrafficSources',
    numberPoolAttachTrafficSources: 'numberPoolAttachTrafficSources',
    rates: 'rates',
}
